export default __webpack_public_path__ + "static/media/sandero-gallery-12.2b4585b9.jpg";